import { CompanyTypeEnum, DisplayNameEnum } from "@gtpl/shared-models/masters";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('bank_details')
export class BankDetailsEntity{
    @PrimaryGeneratedColumn("increment",{name:'id'})
    id:number;

    @Column("varchar",{
        nullable: false,
       name: "bank_name"
      })
      bankName: string;

      @Column("varchar",{
        nullable: false,
       name: "branch_name"
      })
      branchName: string; 
      
      @Column({
        type:"varchar",
        nullable: false,
        name: "bank_account"
      })
       bankAccount: string; 
        
      @Column({
        type:"varchar",
        nullable: false,
        name: "swift_code"
      })
       swiftCode: string; 
       @Column({
         type:"varchar",
         nullable: false,
         name: "ifsc_code"
       })
        ifscCode: string; 
        @Column({
          type:"varchar",
          nullable: false,
          name: "bank_address"
        })
         bankAddress: string; 
       @CreateDateColumn({
        name: "created_at",
        type: "datetime"
      })
      createdAt: Date;
    
      @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;

  
  @Column("boolean", {
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @VersionColumn({
    type:'enum',
    nullable: false,
    name: "company"
  })
  company: CompanyTypeEnum

@Column({
  type: 'enum',
  nullable:true,
  name:"display_name",
  enum: DisplayNameEnum,
})
displayName:DisplayNameEnum;
}